import ComponentsFactory from 'foundation/components-factory';
import MyAccountUrlComponent from './js/my-account-url.component';

ComponentsFactory.getInstance().define('my-account-url', MyAccountUrlComponent);
